import React, {Component, createRef} from 'react';
import 'antd/dist/antd.css';
import { Typography } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import { Form, Input, Select, Row, Col, message, Button, AutoComplete, Spin } from 'antd';

import {register} from '../utils/JWTAuth';

const { Option } = Select;
const AutoCompleteOption = AutoComplete.Option;
const { Title } = Typography;
let values, state;

const success = (messages) => {
  message.success(messages);
};

const error = (messages) => {
  message.error(messages);
};

const warning = (messages) => {
  message.warning(messages);
};




class FormTitular extends Component{

  constructor(){
    super(); 

    state = this;

    this.state = {
      mostrar_otro_cargo: false,
      nombre_comite: 'Comités',
      loading: false
    };

    this.otra_profesion = React.createRef();
  }

  componentDidMount(){
    switch(this.props.match.params.num_comite){
      case '1': this.setState({nombre_comite:'Comité de Seguridad Vial'}); break;
      case '2': this.setState({nombre_comite:'Comité de Prevención y Combate al Delito'}); break;
      case '3': this.setState({nombre_comite:'Comité de Movilidad'}); break;
      case '4': this.setState({nombre_comite:'Comité Ferroviario'}); break;
      case '5': this.setState({nombre_comite:'Comité Jurídico'}); break;
      case '6': this.setState({nombre_comite:'Comité Técnico'}); break;
      default:  break;
  }
}

  cambiarProfesion(value){
    console.log(`selected ${value}`);
    if(value == 'otro'){
      state.setState({mostrar_otro_cargo: true});
    }else{
      state.setState({mostrar_otro_cargo: false});
    }
  }


    state = {
        confirmDirty: false,
        autoCompleteResult: [],
      };

      handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
          if (!err) {

            state.setState({
              loading: true
            });

            values['comite'] = this.props.match.params.num_comite;
            
            if(values['profesion'] == 'otro'){
              values['profesion'] = values['otro_cargo'];
              delete values['otro_cargo'];
            }
            

           register(values).then(data=>{

            state.setState({
              loading: false
            });

              switch(data.status){
                case 3:
                  success('Usuario registrado exitosamente');
                  window.location.href = `/login/${this.props.match.params.comite}/${this.props.match.params.num_comite}`;
                break;
                case 5:
                  error('Error de conexión');
                  break;
                default:
                  warning(data.data);
                  break;
              }

            });

          }
        });

        

      };
    
      handleConfirmBlur = e => {
        const { value } = e.target;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
      };
    
      compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('password')) {
          callback('Las contraseñas no son las mismas');
        } else {
          callback();
        }
      };
    
      validateToNextPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && this.state.confirmDirty) {
          form.validateFields(['confirm'], { force: true });
        }
        callback();
      };
    
      handleWebsiteChange = value => {
        let autoCompleteResult;
        if (!value) {
          autoCompleteResult = [];
        } else {
          autoCompleteResult = ['.com', '.org', '.net'].map(domain => `${value}${domain}`);
        }
        this.setState({ autoCompleteResult });
      };

      existeLogin(){

      }
    
      render() {

        const { getFieldDecorator } = this.props.form;
        const { autoCompleteResult } = this.state;  

        const formItemLayout = {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 8 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
          },
        };
    
        return (
          <Spin spinning={this.state.loading}>
          <Row>
            <Col span={24} style={{ textAlign:'center' }}>
              <h1>{this.state.nombre_comite}</h1>
              <p style={{fontSize:'18px'}}>Si ya estas registrado en otro comité y serás titular de éste da clic
              <Link to={`/comite/${this.props.match.params.comite}/${this.props.match.params.num_comite}`} style={{color:'blue', fontWeight:'bold'}}> aquí</Link>
            </p>
            <Title type="blue">Registro</Title>
            </Col>
          
         <Col span={18} offset={2} style={{ textAlign:'center' }}>
          <Form {...formItemLayout} id="form_titular"  style={{textAlign:'center'}}  onSubmit={this.handleSubmit}>

           

            <Form.Item label="Correo Electrónico">
              {getFieldDecorator('email', {
                rules: [
                  {
                    type: 'email',
                    message: 'Ingrese un correo válido!',
                  },
                  {
                    required: true,
                    message: 'Ingrese un correo válido!',
                  },
                ],
              })(<Input />)}
            </Form.Item>
            <Form.Item label="Contraseña" hasFeedback>
              {getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: 'Tu contraseña debe ser mayor a 8 dígitos',
                    min:8,
                  },
                  {
                    validator: this.validateToNextPassword,
                  },
                ],
              })(<Input.Password />)}
            </Form.Item>
            

            <Form.Item
              label={
                <span>
                  Cargo en la Empresa
                </span>
              }
            >
              {getFieldDecorator('cargo', {
                rules: [{ required: true, message: 'Registra tu cargo', whitespace: true }],
              })(<Input />)}
            </Form.Item>

           

            <Form.Item
              label={
                <span>
                  Nombre Completo
                </span>
              }
            >
              {getFieldDecorator('nombre', {
                rules: [{ required: true, message: 'Ingresa tu nombre', whitespace: true }],
              })(<Input />)}
            </Form.Item>

            
            
            <Form.Item label="Teléfono">
              {getFieldDecorator('telefono', {
                rules: [{ required: true, message: 'Ingresa tu teléfono' }],
              })(<Input style={{ width: '100%' }} />)}
            </Form.Item>
           
            <Form.Item
              label={
                <span>
                  Profesión
                </span>
              }
            >
              {getFieldDecorator('profesion', {
                rules: [{ required: true, message: 'Selecciona tu profesión', whitespace: true }],
              })(
                <Select
                  showSearch
                  onChange={state.cambiarProfesion}
                  placeholder=""
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value="Ing.">Ing</Option>
                  <Option value="Lic.">Lic.</Option>
                  <Option value="Maestro">Maestro</Option>
                  <Option value="Contador Publico">Contador Público</Option>
                  <Option value="otro">Otro (Especificar)</Option>
                </Select>
              )}
            </Form.Item>

            {state.state.mostrar_otro_cargo &&
           ( <Form.Item ref={state.otra_profesion} label="Otro">
              {getFieldDecorator('otro_cargo', {
                rules: [{ required: false, message: 'Ingresa tu cargo' }],
              })(<Input style={{ width: '100%' }} />)}
            </Form.Item>)}

            <Form.Item
              label={
                <span>
                  Código de Empresa
                </span>
              }
            >
              {getFieldDecorator('codigo_empresa', {
                rules: [{ required: true }],
              })(<Input />)}
              
            </Form.Item>
            <Row>
            <Col span={8} offset={12} style={{ textAlign:'center' }}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Registrar
              </Button>
            </Form.Item>
            </Col>
            </Row>
            </Form>
          </Col>
            <Col span={24} style={{ textAlign:'center' }}>
            
            <br />
            
            <p>
              <Link to={`/login/${this.props.match.params.comite}/${this.props.match.params.num_comite}`}> regresar</Link>
            </p>
</Col>
          
          </Row>
        </Spin>
        );
      }
}

const WrappedRegistrationForm = Form.create({ name: 'register' })(FormTitular);

export default WrappedRegistrationForm;
